import { render, staticRenderFns } from "./EditNewsSource.vue?vue&type=template&id=f98ad834&scoped=true&"
import script from "./EditNewsSource.vue?vue&type=script&lang=js&"
export * from "./EditNewsSource.vue?vue&type=script&lang=js&"
import style0 from "./EditNewsSource.vue?vue&type=style&index=0&id=f98ad834&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98ad834",
  null
  
)

export default component.exports